import App from "./App";
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import './i18n';

// Return response as response.data for every request to avoid response.data.data
axios.interceptors.response.use((response) => {
  return response.data;
});

ReactDOM.render(<App />, document.getElementById('app'));
